export default __webpack_public_path__ + "static/media/BOWLANI-Logo-with-claim.c861f473.svg";